import { useQuery } from '@tanstack/react-query';
import { featureFlagApi } from '@/services/featureFlagApi';
import { useAuth } from './useAuth';

export const useFeatureFlags = () => {
  const { isAuthenticated } = useAuth();

  const { data: flags, isLoading } = useQuery({
    queryKey: ['feature-flags'],
    queryFn: () => featureFlagApi.getFlags(),
    enabled: isAuthenticated,
    staleTime: 60 * 1000,
  });

  // Fail closed while loading/on error/unknown key — these flags gate
  // features that are deliberately unreleased by default.
  const isFeatureEnabled = (key: string): boolean => flags?.[key] ?? false;

  return { flags, isLoading, isFeatureEnabled };
};
